exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-border[data-v-00a5c5c9]{border-radius:.5rem;border:1px solid #ccc!important}[data-v-00a5c5c9] .child .v-table__overflow{overflow-x:scroll!important}", ""]);

// exports
